var _rect, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.08,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#1B49EA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9457_3294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0589 18.0879C23.8911 18.0879 23.7301 18.1546 23.6114 18.2732C23.4928 18.3919 23.4261 18.5529 23.4261 18.7207V20.8818C23.4261 21.3911 23.2237 21.8796 22.8636 22.2398C22.5034 22.6 22.0149 22.8023 21.5055 22.8023H10.4946C9.98519 22.8023 9.49668 22.6 9.1365 22.2398C8.77632 21.8796 8.57397 21.3911 8.57397 20.8818V18.7207C8.57397 18.5529 8.5073 18.3919 8.38863 18.2732C8.26995 18.1546 8.10899 18.0879 7.94116 18.0879C7.77333 18.0879 7.61237 18.1546 7.4937 18.2732C7.37502 18.3919 7.30835 18.5529 7.30835 18.7207V20.8818C7.30919 21.7265 7.64515 22.5365 8.24249 23.1338C8.83984 23.7312 9.64978 24.0671 10.4946 24.068H21.5055C22.3503 24.0671 23.1602 23.7312 23.7576 23.1338C24.3549 22.5365 24.6909 21.7265 24.6917 20.8818V18.7207C24.6917 18.5529 24.625 18.3919 24.5064 18.2732C24.3877 18.1546 24.2267 18.0879 24.0589 18.0879Z",
    fill: "#1B49EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5508 19.9361C15.6096 19.9954 15.6796 20.0425 15.7567 20.0746C15.8338 20.1067 15.9165 20.1233 16.0001 20.1233C16.0836 20.1233 16.1663 20.1067 16.2434 20.0746C16.3205 20.0425 16.3905 19.9954 16.4494 19.9361L20.0501 16.3354C20.1505 16.2145 20.2024 16.0605 20.1956 15.9035C20.1888 15.7465 20.1238 15.5976 20.0132 15.4859C19.9027 15.3741 19.7545 15.3075 19.5975 15.299C19.4406 15.2906 19.2861 15.3408 19.1641 15.44L16.6329 17.9712V8.56445C16.6329 8.39662 16.5662 8.23566 16.4475 8.11699C16.3289 7.99831 16.1679 7.93164 16.0001 7.93164C15.8322 7.93164 15.6713 7.99831 15.5526 8.11699C15.4339 8.23566 15.3673 8.39662 15.3673 8.56445V17.9617L12.836 15.4305C12.7173 15.3117 12.5562 15.245 12.3883 15.245C12.2204 15.245 12.0593 15.3117 11.9406 15.4305C11.8218 15.5492 11.7551 15.7103 11.7551 15.8782C11.7551 16.0461 11.8218 16.2072 11.9406 16.3259L15.5508 19.9361Z",
    fill: "#1B49EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9457_3294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.38afa0b06589c84ced2d7f4973c20810.svg";
export { ForwardRef as ReactComponent };